import { useMemo } from "react";
import { useSelector } from "react-redux";
import { USER_ROLE } from "../constants/constants";
import { getSessionStorageData } from "../utility/Utils";
import { STORAGE } from "../constants/storageConstants";

const useUserRole = () => {
  const userRole = useSelector((state) => state.userRoleReducer.userRole);

  const standardizedRole = useMemo(() => {
    return (userRole || getSessionStorageData(STORAGE.SELECTED_ROLE) || "").toLowerCase();
  }, [userRole]);

  return {
    standardizedRole,
    isSiteManager: standardizedRole === USER_ROLE.SITE_MANAGER.toLowerCase(),
    isSiteViewer: standardizedRole === USER_ROLE.SITE_VIEWER.toLowerCase(),
    isAdmin: standardizedRole === USER_ROLE.ADMIN.toLowerCase(),
  };
};

export default useUserRole;
